import $ from "jquery";

const getCheckedCheckboxes = (parameters, term) => {
    const checkboxes = document.querySelectorAll(
        'input[name="' + term + '"]:checked'
    );
    let count = "";

    if (checkboxes.length > 0) {
        const values = [];
        checkboxes.forEach((checkbox) => {
            values.push(checkbox.value);
        });
        parameters[term] = values.join(",");
        count = "(" + values.length + ")";
    }

    $(".filter__count").html(count);
    return parameters;
};

const setActiveCheckboxes = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const params = urlParams.get("cat");

    if (!!params) {
        const values = params.split(",");
        const count = "(" + values.length + ")";

        $(".filter__count").html(count);

        values.map((value) => {
            const checkbox = $(`#checkbox-${value}`);
            checkbox.attr("checked", "checked");
        });
    }
};

const filterAjax = (el) => {
    $(".filter__checkbox").on("change", function (e) {
        const parameters = {};
        const baseUrl = window.location.pathname;
        let type = el.getAttribute("data-query-type");

        // Capture selected checkboxes
        getCheckedCheckboxes(parameters, type);

        // Check if a search query exists in the current URL
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('search')) {
            const searchTerm = searchParams.get('search');
            parameters['search'] = searchTerm;
        }

        if (Object.keys(parameters).length > 0) {
            const queryString = Object.keys(parameters)
                .map((key) => {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(
                        parameters[key]
                    )}`;
                })
                .join("&");

            const searchString = window.location.search;

            let preQueryString = searchString
                ? searchString.replace(/&.*/, "")
                : "?";

            if (preQueryString === "?") {
                preQueryString = "?";
            } else {
                preQueryString += "&";
            }

            // Update the URL with the new query string
            window.history.pushState(null, "", `${baseUrl}?${queryString}`);
            console.log("Query string is:", queryString);

        } else {
            window.history.pushState(null, "", baseUrl);
        }

        $(el).trigger("submit");
    });

    $(el).on("submit", (e) => {
        e.preventDefault();

        let type = el.getAttribute("data-query-type");
        $.ajax({
            type: "POST",
            url: "/wp/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "filter_" + type,
                types: $(el).serializeArray(),
                ajaxUrl: window.location.href,
                search: $(el).data("search-query"),
                postType: $(el).data("post-type"),
            },
            success: function (res) {
                $(".js-search-list").html(res);
            },
            error: function (err) {
                console.error(err);
            },
        });
    });

    setActiveCheckboxes();
};

export default filterAjax;
